import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="relative bg-dark-card pt-16 pb-8">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand/20 to-transparent" />

      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          <div>
            <button
              onClick={() => scrollTo("hero")}
              className="mb-4 block transition-opacity duration-300 hover:opacity-80"
            >
              <img
                src="https://public.readdy.ai/ai/img_res/bc150b37-bb54-432c-aacd-0e9457b45b43.png"
                alt="Manova Digital"
                className="h-12 md:h-14 w-auto object-contain"
              />
            </button>
            <p className="text-sm text-white/60 font-light tracking-wide max-w-xs leading-relaxed">
              Une présence digitale pensée pour vous <span className="text-brand font-medium">démarquer</span>.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Navigation
            </h4>
            <div className="space-y-3">
              {[
                { label: "Services", id: "services" },
                { label: "Réalisations", id: "realisations" },
                { label: "Process", id: "process" },
                { label: "Contact", id: "contact" },
              ].map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollTo(link.id)}
                  className="block text-sm text-white/50 hover:text-brand transition-colors"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="space-y-3">
              <a
                href="tel:+41764603835"
                className="flex items-center gap-3 text-sm text-white/50 hover:text-brand transition-colors"
              >
                <i className="ri-phone-line text-brand"></i>
                +41 76 460 38 35
              </a>
              <div className="flex items-center gap-3 text-sm text-white/50">
                <i className="ri-map-pin-line text-brand"></i>
                Montreux, Suisse
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30 font-light">
            &copy; {new Date().getFullYear()} Manova Digital. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <button
              onClick={() => navigate("/mentions-legales")}
              className="text-xs text-white/30 hover:text-brand transition-colors"
            >
              Mentions légales
            </button>
            <button
              onClick={() => navigate("/confidentialite")}
              className="text-xs text-white/30 hover:text-brand transition-colors"
            >
              Confidentialité
            </button>
            <a
              href="https://www.instagram.com/manova_digital?igsh=ZnZjNHNqYWt4djNs"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/30 hover:text-brand transition-colors"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a
              href="https://www.tiktok.com/@manovadigital?_r=1&_t=ZN-97LRO0s1IWs"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/30 hover:text-brand transition-colors"
            >
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
